/**
 * Shared animation tokens for framer-motion.
 * Design system easing: [0.16, 1, 0.3, 1] (expo-out) for most animations.
 * Content reveals: [0.25, 1, 0.5, 1] (easeOutQuart).
 */

/** Standard expo-out easing used across the site */
export const expoOut = [0.16, 1, 0.3, 1] as const

/** EaseOutQuart for content reveals (accordion, biomarker rows) */
export const easeOutQuart = [0.25, 1, 0.5, 1] as const

/**
 * Creates a fade-up animation that triggers when the element enters the viewport.
 * Used by report mockup nav, sidebar, and similar viewport-triggered components.
 */
export const createViewportFadeUp = (
  delay: number = 0,
  { y = 12, scale }: { y?: number; scale?: number } = {}
) => ({
  initial: { opacity: 0, y, ...(scale != null ? { scale } : {}) } as const,
  whileInView: {
    opacity: 1,
    y: 0,
    ...(scale != null ? { scale: 1 } : {}),
  } as const,
  viewport: { once: true } as const,
  transition: { duration: 0.6, ease: expoOut, delay },
})

/**
 * Creates a fade-up animation that plays immediately (on mount).
 * Used by report mockup cards and similar eagerly-animated components.
 */
export const createMountFadeUp = (delay: number = 0) => ({
  initial: { opacity: 0, y: 12 } as const,
  animate: { opacity: 1, y: 0 } as const,
  transition: {
    default: { duration: 0.1 },
    opacity: { duration: 0.6, ease: expoOut, delay },
    y: { duration: 0.6, ease: expoOut, delay },
  },
})

/** Standard spring for interactive animations */
export const spring = { type: "spring" as const, stiffness: 400, damping: 30 }
